<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
      <h1 class="page-title">建物マスタ情報一覧</h1>
      <div class="mb-2">
      <router-link
        v-if="userRole == 0 || userRole == 999"
        :to="{ path: '/create-building', query: getSearchQuery() }"
        class="btn btn-sm btn-primary me-2"
      >
        建物マスタ情報作成
      </router-link> <!-- 建物マスタ情報作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>
    
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button
          v-if="userRole == 0 || userRole == 999"
          type="button"
          class="btn btn-sm btn-outline-primary me-2"
          data-bs-toggle="modal"
          data-bs-target="#fieldVisibilityModalBuilding"
          @click="openFieldVisibilityModal"
        >
          測定表示項目設定
        </button>

        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
          {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>建物情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="fieldVisibilityModalBuilding" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5">測定システム表示項目設定（建物）</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <table class="table table-bordered align-middle">
                <thead class="table-light">
                  <tr>
                    <th>項目名</th>
                    <th>キー</th>
                    <th class="text-center">表示</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="field in fieldVisibilityFields" :key="field.field_name">
                    <td>{{ field.field_label }}</td>
                    <td class="text-muted">{{ field.field_name }}</td>
                    <td class="text-center">
                      <div class="form-check form-switch d-inline-block">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="field.readable"
                          :disabled="field.configurable === false || isSavingFieldVisibility"
                          @change="updateFieldReadable(field.field_name, $event.target.checked)"
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
              <button type="button" class="btn btn-primary" :disabled="isSavingFieldVisibility" @click="saveFieldVisibility">保存</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchBuildings"> <!-- 背景色を薄く設定 -->
          <div class="row g-3 align-items-center">

            <!-- 顧客検索 -->
            <div class="col-auto">
              <CustomerSelectBox
                v-model="searchCustomerName"
                :options="customers"
                placeholder="顧客名で検索"
                :formatter="c => c.customer_nm"
              />
            </div>

            <!-- 建物種別検索 -->
            <div class="col-auto">
              <BuildingTypeSelectBox
                v-model="searchBuildingTypeName"
                :options="buildingTypes"
                placeholder="建物種別で検索"
                :formatter="bt => bt.building_type_nm"
              />
            </div>
            
            <!-- 建物名検索 -->
            <div class="col-auto">
              <input type="text" id="searchBuildingName" class="form-control" v-model="searchBuildingName" placeholder="建物名で検索">
            </div>

            <!-- 社内担当者検索 -->
            <div class="col-auto">
              <UserSelectBox
                v-model="searchInchargePersonName"
                :options="users"
                placeholder="社内担当者で検索"
                :formatter="v => v.name"
              />
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="buildingDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-sm btn-primary mx-1">検索</button>
              <button type="button" class="btn btn-sm btn-secondary mx-1" @click="searchResetBuildings">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">ID</th>
            <th class="text-nowrap">建物名</th>
            <th class="text-nowrap">区分</th>
            <th class="text-nowrap">顧客名</th>
            <th class="text-nowrap">所在地</th>
            <th class="text-nowrap">契約月</th>
            <th class="text-nowrap">定額請求</th>
            <th class="text-nowrap">社内担当者</th>
            <th class="text-nowrap">契約終了日</th>
            <th class="text-nowrap">測定表示</th>
            <th class="btn-cell">マスタ情報操作</th>
            <th class="btn-cell">年間予定作業</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="building in buildings" :key="building.id" :class="{ 'no-active-building': building.del_flg == 1 }">
            <td>{{ building.id }}</td>
            <td>{{ building.building_nm }}</td>
            <td class="text-nowrap">{{ building.m_building_type.building_type_nm }}</td>
            <td class="multiline-text">{{ building.m_customer.customer_nm }}</td>
            <td>〒{{ building.postal_code }} {{building.prefecture}}{{building.city}}{{building.other_address}}</td>
            <td class="text-nowrap"><span v-if="building.contract_dt">{{ new Date(building.contract_dt).getMonth() + 1 }}月</span></td>
            <td>
              {{
                {
                  true: "対象",
                  false: "",
                }[building.fixed_fee_billing]
              }}
            </td>
            <td class="text-nowrap">{{ building.internal_person?.name }}</td>
            <td class="text-nowrap">{{ building.contract_end_dt }}</td>
            <td class="text-nowrap">
              <div v-if="userRole == 0 || userRole == 999" class="form-check form-switch d-inline-block">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="isVisibleInMeasure(building.id)"
                  @change="toggleMeasureVisibility(building.id, $event.target.checked)"
                >
              </div>
              <span v-else>{{ isVisibleInMeasure(building.id) ? '表示' : '非表示' }}</span>
            </td>
            <td class="btn-cell text-nowrap">
              <router-link :to="{ name: 'BuildingDetail', params: { id: building.id }, query: getSearchQuery() }"> <!-- 建物情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info me-2">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'BuildingEdit', params: { id: building.id }, query: getSearchQuery() }"> <!-- 建物情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success me-2">編集</button>
              </router-link>

              <button v-if="building.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(building.id)">削除</button>
              <button v-if="building.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(building.id)">復元</button>
            </td>
            <td class="annual-work-btn-cell">
              <!-- 昨年度ボタン -->
              <router-link
                v-if="prevFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: prevFiscal(building.contract_dt).start }, query: getSearchQuery() }">
                <button type="button" class="btn btn-sm btn-success mx-1 my-1">
                  {{ prevFiscal(building.contract_dt).label }}
                </button>
              </router-link>

              <!-- 今年度ボタン -->
              <router-link
                v-if="currentFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: currentFiscal(building.contract_dt).start }, query: getSearchQuery() }">
                <button type="button" class="btn btn-sm btn-warning mx-1 my-1">
                  {{ currentFiscal(building.contract_dt).label }}
                </button>
              </router-link>

              <!-- 来年度ボタン -->
              <router-link
                v-if="nextFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: nextFiscal(building.contract_dt).start }, query: getSearchQuery() }">
                <button type="button" class="btn btn-sm btn-info mx-1 my-1">
                  {{ nextFiscal(building.contract_dt).label }}
                </button>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getBuildings,
  getSelectBoxCustomers,
  getBuildingTypes,
  deleteBuilding,
  restoreBuilding,
  getSelectBoxUsers,
  exportBuildingsCsv,
  importBuildingsCsv,
  getMasterFieldVisibilities,
  updateMasterFieldVisibilities,
  getMasterRecordVisibilities,
  updateMasterRecordVisibility
} from '@/api/axios';
import { Modal } from 'bootstrap';
import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue'
import BuildingTypeSelectBox from '@/components/searchSelectBoxes/BuildingTypeSelectBox.vue'
import UserSelectBox from '@/components/searchSelectBoxes/UserSelectBox.vue';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    CustomerSelectBox,
    BuildingTypeSelectBox,
    UserSelectBox,
    SearchPanelWrapper,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const TARGET_CLIENT_SYSTEM = 'measure';
    const title = ref('建物情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const buildings = ref([]);
    const customers = ref([]);
    const buildingTypes = ref([]);
    const users = ref([]);
    const selectedFile = ref(null);
    const recordVisibilityMap = ref({});
    const fieldVisibilityFields = ref([]);
    const isSavingFieldVisibility = ref(false);

     // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);
    const paramsIdToRestore = ref(null);

    // 検索用のデータプロパティ
    const searchCustomerName = ref('');
    const searchBuildingName = ref('');
    const searchBuildingTypeName = ref('');
    const searchInchargePersonName = ref('');
    const searchDeletedStatus = ref('active');

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      building_customer_id: searchCustomerName.value,
      building_building_type_id: searchBuildingTypeName.value,
      building_name: searchBuildingName.value,
      building_incharge_person_id: searchInchargePersonName.value,
      building_deleted_status: searchDeletedStatus.value,
      building_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const isVisibleInMeasure = (recordId) => recordVisibilityMap.value[recordId] !== false;

    const fetchRecordVisibilities = async () => {
      const recordIds = buildings.value.map(building => building.id);
      if (recordIds.length === 0) {
        recordVisibilityMap.value = {};
        return;
      }

      try {
        const response = await getMasterRecordVisibilities('building', TARGET_CLIENT_SYSTEM, recordIds);
        const visibilities = response.data?.visibilities || {};
        recordVisibilityMap.value = Object.fromEntries(
          recordIds.map(id => [id, visibilities[String(id)] !== false])
        );
      } catch (error) {
        console.error('建物表示可否データの取得に失敗しました:', error);
      }
    };

    const toggleMeasureVisibility = async (recordId, visible) => {
      const previous = isVisibleInMeasure(recordId);
      recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: visible };

      try {
        await updateMasterRecordVisibility('building', TARGET_CLIENT_SYSTEM, recordId, visible);
      } catch (error) {
        recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: previous };
        store.dispatch('setFlashMessage', { message: '測定表示設定の更新に失敗しました', type: 'danger' });
      }
    };

    const openFieldVisibilityModal = async () => {
      try {
        const response = await getMasterFieldVisibilities('building', TARGET_CLIENT_SYSTEM);
        fieldVisibilityFields.value = response.data?.fields || [];
      } catch (error) {
        console.error('表示項目設定の取得に失敗しました:', error);
      }
    };

    const updateFieldReadable = (fieldName, readable) => {
      fieldVisibilityFields.value = fieldVisibilityFields.value.map(field => (
        field.field_name === fieldName ? { ...field, readable } : field
      ));
    };

    const closeFieldVisibilityModal = () => {
      const modalElement = document.getElementById('fieldVisibilityModalBuilding');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    const saveFieldVisibility = async () => {
      isSavingFieldVisibility.value = true;
      try {
        const fields = fieldVisibilityFields.value
          .filter(field => field.configurable !== false)
          .map(field => ({
            field_name: field.field_name,
            readable: field.readable
          }));

        await updateMasterFieldVisibilities('building', TARGET_CLIENT_SYSTEM, fields);
        await fetchBuildings(currentPage.value);
        store.dispatch('setFlashMessage', { message: '測定システム表示項目を更新しました', type: 'success' });
        closeFieldVisibilityModal();
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '表示項目設定の更新に失敗しました', type: 'danger' });
      } finally {
        isSavingFieldVisibility.value = false;
      }
    };

    const fetchBuildings = async (page = 1) => {
      try {
        const response = await getBuildings({
          customer_id: searchCustomerName.value,
          building_type_id: searchBuildingTypeName.value,
          building_nm: searchBuildingName.value,
          incharge_person_id: searchInchargePersonName.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        buildings.value = response.data.buildings;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
        await fetchRecordVisibilities();
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getSelectBoxCustomers();
        customers.value = response.data;
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }

      // 建物種別情報（検索用）
      try {
        const response = await getBuildingTypes();
        buildingTypes.value = response.data.building_types;
      } catch (error) {
        console.error('建物種別情報ーデータの取得に失敗しました:', error);
      }

      // ユーザ情報（検索用）
      try {
        const response = await getSelectBoxUsers();
        users.value = response.data;
      } catch (error) {
        console.error('ユーザ情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchBuildings(page);

        const q = getSearchQuery();
        q.building_page = page;

        router.replace({
          path: '/buildings',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    const handleDeleteClick = (buildingId) => {
      paramsIdToDelete.value = buildingId;
    };

    const handleRestoreClick = (buildingId) => {
      paramsIdToRestore.value = buildingId;
    };
    
    const handleConfirmDelete = async (buildingId) => {
      try {
        await deleteBuilding(buildingId);
        store.dispatch('setFlashMessage', { message: '建物情報が削除されました', type: 'success' });
        await fetchBuildings(currentPage.value);
      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: '建物情報削除に失敗しました', type: 'danger' });
      }
    };

    const handleConfirmRestore = async (buildingId) => {
      try {
        await restoreBuilding(buildingId);
        store.dispatch('setFlashMessage', { message: '建物情報が復元されました', type: 'success' });
        await fetchBuildings(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '建物情報復元に失敗しました', type: 'danger' });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportBuildingsCsv({
          customer_id: searchCustomerName.value,
          building_type_id: searchBuildingTypeName.value,
          building_nm: searchBuildingName.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `m_buildings_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importBuildingsCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // 顧客情報の再取得
        await fetchBuildings();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // 年度別の取得関数
    const prevFiscal = (date) => getFiscalYearRange(date, -1);
    const currentFiscal = (date) => getFiscalYearRange(date, 0);
    const nextFiscal = (date) => getFiscalYearRange(date, 1);

    // 汎用の年度範囲関数（共通ロジック）
    const getFiscalYearRange = (contractDate, offset = 0) => {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const contractMonth = contractDate ? new Date(contractDate).getMonth() + 1 : 1;

      const startYear = contractMonth <= currentMonth ? currentYear + offset : currentYear + offset - 1;

      const startMonth = new Date(startYear, contractMonth - 1);
      const endMonth = new Date(startYear + 1, contractMonth - 2); // 翌年の契約月の前月

      return {
        start: `${startMonth.getFullYear()}-${startMonth.getMonth() + 1}-${startMonth.getDate()}`,
        end: endMonth,
        label: `${startMonth.getFullYear()}年${startMonth.getMonth() + 1}月〜${endMonth.getFullYear()}年${endMonth.getMonth() + 1}月`
      };
    };

    // 建物を検索するメソッド
    const searchBuildings = async () => {
      await fetchBuildings(1);

      const q = getSearchQuery();
      q.building_page = 1;

      router.push({
        path: '/buildings',
        query: q
      });
    };

    // 建物を検索リセットするメソッド
    const searchResetBuildings = async () => {
      searchCustomerName.value = '';
      searchBuildingName.value = '';
      searchBuildingTypeName.value = '';
      searchInchargePersonName.value = '';
      searchDeletedStatus.value = 'active';

      await fetchBuildings(1);

      const q = getSearchQuery();
      q.building_page = 1;

      router.replace({
        path: '/buildings',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(() => {
      const q = route.query;

      searchCustomerName.value = q.building_customer_id || '';
      searchBuildingName.value = q.building_name || '';
      searchBuildingTypeName.value = q.building_building_type_id || '';
      searchInchargePersonName.value = q.building_incharge_person_id || '';
      searchDeletedStatus.value = q.building_deleted_status || 'active';
      currentPage.value = q.building_page ? Number(q.building_page) : 1;

      fetchBuildings(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      buildings,
      customers,
      buildingTypes,
      users,
      paramsIdToDelete,
      paramsIdToRestore,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      submitFile,
      errorMessages,
      clearErrorMessages,
      searchCustomerName,
      searchBuildingName,
      searchBuildingTypeName,
      searchInchargePersonName,
      searchDeletedStatus,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      prevFiscal,
      currentFiscal,
      nextFiscal,
      searchBuildings,
      searchResetBuildings,
      isVisibleInMeasure,
      toggleMeasureVisibility,
      openFieldVisibilityModal,
      updateFieldReadable,
      saveFieldVisibility,
      fieldVisibilityFields,
      isSavingFieldVisibility,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
.master-table .annual-work-btn-cell{
  width: 212px;
  min-width: 212px;
  max-width: 212px;
}

.no-active-building td {
  background-color: #aaa;
}
</style>
